import http from '../utils/http.js'

// 数据开放
// 专家库
export const expert = {
    ...getApi('expert'),
    frontList(data) {
        return http.post(`/expert/front/list`)
    },
}
// 人才招聘
export const ralentRecruitment = getApi('recruitment')
// 企业名录
export const enterpriseDirectory = getApi('recruitment')

function getApi(type) {
    return {
        pageQuery(data) {
            return http.post(`/${type}/pageQuery/${data.page}/${data.size}`, data)
        },
        frontPageQuery: (data)=> {
            return http.post(`/${type}/front/pageQuery/${data.page}/${data.size}`, data)
        },
        add(data) {
            return http.post(`/${type}/add`, data)
        },
        update(data) {
            return http.put(`/${type}/update`, {...data, state: 0})
        },
        del(ids) {
            return http.delete(`/${type}/del`, ids)
        },
        getDocumentDetails(id) {
            return http.get(`/${type}/getDocumentDetails/${id}`)
        },
        audit(data) {
            return http.post(`/${type}/audit`, data)
        }
    }

}